import { render, staticRenderFns } from "./promotion-product-list-preview.component.vue?vue&type=template&id=5c7ae7fa&scoped=true"
import script from "./promotion-product-list-preview.component.vue?vue&type=script&lang=ts"
export * from "./promotion-product-list-preview.component.vue?vue&type=script&lang=ts"
import style0 from "./promotion-product-list-preview.component.vue?vue&type=style&index=0&id=5c7ae7fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7ae7fa",
  null
  
)

export default component.exports